import { Scale, FileText, Shield, Phone, ChevronRight, CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const SERVICES = [
  { icon: '📋', title: 'Tư vấn hợp đồng sang nhượng', desc: 'Soạn thảo, rà soát hợp đồng sang nhượng mặt bằng, thương hiệu F&B đúng pháp lý.' },
  { icon: '🏢', title: 'Đăng ký kinh doanh', desc: 'Hỗ trợ thủ tục thành lập doanh nghiệp, hộ kinh doanh trong ngành F&B.' },
  { icon: '🔒', title: 'Bảo vệ thương hiệu', desc: 'Đăng ký nhãn hiệu, bản quyền cho thương hiệu F&B tại Việt Nam và quốc tế.' },
  { icon: '⚖️', title: 'Giải quyết tranh chấp', desc: 'Tư vấn và đại diện pháp lý trong các tranh chấp hợp đồng, sang nhượng.' },
  { icon: '📄', title: 'Giấy phép an toàn thực phẩm', desc: 'Xin cấp giấy phép vệ sinh an toàn thực phẩm, giấy phép kinh doanh rượu.' },
  { icon: '🌐', title: 'Pháp lý nhượng quyền quốc tế', desc: 'Tư vấn pháp lý cho mô hình nhượng quyền từ nước ngoài vào Việt Nam.' },
];
const FAQS = [
  { q: 'Hợp đồng sang nhượng cần những điều khoản gì?', a: 'Một hợp đồng sang nhượng chuẩn cần có: thông tin các bên, mô tả tài sản sang nhượng, giá trị, phương thức thanh toán, thời hạn, quyền và nghĩa vụ, điều khoản giải quyết tranh chấp.' },
  { q: 'Thời gian đăng ký kinh doanh mất bao lâu?', a: 'Thông thường từ 3-5 ngày làm việc với đầy đủ hồ sơ. Trường hợp cần bổ sung có thể kéo dài 7-10 ngày.' },
  { q: 'Chi phí tư vấn pháp lý như thế nào?', a: 'Chi phí tùy theo loại dịch vụ và mức độ phức tạp. Liên hệ trực tiếp để nhận báo giá miễn phí.' },
];

export default function TuVanPhapLyPage() {
  return (
    <div className="max-w-5xl mx-auto space-y-10 animate-fade-in">
      {/* Hero */}
      <div className="rounded-2xl overflow-hidden relative p-8 md:p-12"
           style={{ background: 'linear-gradient(135deg, #ea580c 0%, #f97316 50%, #fb923c 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }} />
        <div className="relative z-10 flex items-start gap-5">
          <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
            <Scale size={32} className="text-white" />
          </div>
          <div>
            <p className="text-white/70 text-sm font-medium mb-1">Dịch vụ hỗ trợ</p>
            <h1 className="font-display font-black text-3xl text-white mb-2">Tư vấn pháp lý</h1>
            <p className="text-white/80 text-base max-w-xl">
              Đội ngũ luật sư và chuyên gia pháp lý giàu kinh nghiệm trong ngành F&B,
              sẵn sàng hỗ trợ mọi vấn đề pháp lý cho doanh nghiệp của bạn.
            </p>
          </div>
        </div>
      </div>

      {/* Services grid */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>
          Dịch vụ của chúng tôi
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map(s => (
            <div key={s.title} className="fnb-card p-5 cursor-pointer">
              <span className="text-3xl mb-3 block">{s.icon}</span>
              <h3 className="font-semibold text-sm mb-2" style={{ color: 'var(--text-1)' }}>{s.title}</h3>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--text-3)' }}>{s.desc}</p>
              <button className="mt-3 flex items-center gap-1 text-xs font-semibold hover:opacity-80"
                      style={{ color: 'var(--brand)' }}>
                Tìm hiểu thêm <ChevronRight size={12} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Why us */}
      <div className="rounded-2xl p-6 border" style={{ background: 'var(--surface-0)', borderColor: 'var(--border-c)' }}>
        <h2 className="font-display font-bold text-lg mb-5" style={{ color: 'var(--text-1)' }}>Tại sao chọn FNB HUB?</h2>
        <div className="grid sm:grid-cols-3 gap-4">
          {[
            { icon: '🏆', label: '10+ năm kinh nghiệm', desc: 'Chuyên sâu pháp lý ngành F&B' },
            { icon: '👨‍⚖️', label: '50+ luật sư', desc: 'Mạng lưới chuyên gia pháp lý toàn quốc' },
            { icon: '✅', label: '2,000+ hồ sơ', desc: 'Tỷ lệ thành công trên 98%' },
          ].map(item => (
            <div key={item.label} className="flex items-start gap-3 p-3 rounded-xl" style={{ background: 'var(--surface-1)' }}>
              <span className="text-2xl">{item.icon}</span>
              <div>
                <p className="font-semibold text-sm" style={{ color: 'var(--text-1)' }}>{item.label}</p>
                <p className="text-xs mt-0.5" style={{ color: 'var(--text-3)' }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Câu hỏi thường gặp</h2>
        <div className="space-y-3">
          {FAQS.map(faq => (
            <div key={faq.q} className="fnb-card p-4">
              <div className="flex items-start gap-2">
                <CheckCircle2 size={15} className="shrink-0 mt-0.5" style={{ color: 'var(--brand)' }} />
                <div>
                  <p className="font-semibold text-sm mb-1" style={{ color: 'var(--text-1)' }}>{faq.q}</p>
                  <p className="text-xs leading-relaxed" style={{ color: 'var(--text-3)' }}>{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="rounded-2xl p-8 text-center" style={{ background: 'var(--navbar-top)' }}>
        <Phone size={32} className="mx-auto mb-3 text-orange-400" />
        <h3 className="font-display font-black text-xl text-white mb-2">Cần tư vấn ngay?</h3>
        <p className="text-gray-400 text-sm mb-5">Hotline hỗ trợ 24/7: <span className="text-orange-400 font-bold">1800 1234</span></p>
        <button className="btn-brand px-8 py-3 rounded-xl font-semibold">
          Đặt lịch tư vấn miễn phí
        </button>
      </div>
    </div>
  );
}
